module.exports = __webpack_public_path__ + "static/media/blue-check.c7ec6f7e.svg";